module.exports = __webpack_public_path__ + "img/bb5.dbd1f0af.jpg";